import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  boolean {
      const token = localStorage.getItem('token');
      if (token && this.isTokenValid(token)) {
        return true;
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        this.router.navigate(['/auth/logout']);
        return false;
      }
  }

  private isTokenValid(token: string): boolean {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return false;

      const payload = JSON.parse(atob(parts[1]));
      const exp = payload.exp * 1000;

      return new Date().getTime() < exp;
    } catch {
      return false;
    }
  }

}
export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthenticatedGuard).canActivate(next, state);
}
